interface IAppConstants {
  iPosServiceApiKey: string,
  iPosServiceUrl: string
}

const getEnvConfig = (): IAppConstants => {

  return window.config.iPos;
};

export const envConfig: IAppConstants = getEnvConfig();
